import type { ActivityTask } from "../store/useActivityTaskStore";

// HH:MM:SS
export const fmtDuration = (totalSeconds: number) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return [h, m, sec].map((n) => String(n).padStart(2, "0")).join(":");
};

/**
 * ERP-consistent elapsed time.
 *
 * Anchors to the server-computed `elapsedSeconds` (which the backend aligns to
 * ERP's clock), then ticks forward using ONLY the delta since the data was
 * received. This avoids the absolute browser-clock vs server-clock skew that
 * made CRE and ERP disagree.
 */
export const displayElapsed = (a: ActivityTask, anchorMs: number) => {
  const base = a.elapsedSeconds ?? a.totalSeconds ?? 0;
  if (!a.runningSince) return base;
  return base + Math.max(0, (Date.now() - anchorMs) / 1000);
};
